import * as React from 'react';
import { Form } from 'semantic-ui-react';

import json, { Option } from './datos.json';

const arrayVacio: Option[] = [];

export interface Datos {
    region: {
        codigo: string;
        nombre: string;
    };
    comuna: {
        codigo: string;
        nombre: string;
    };
}

const CODIGO_REGION_METROPOLITANA = '13';
export const inicial: Datos = {
    region: {
        codigo: CODIGO_REGION_METROPOLITANA,
        nombre: nombreRegion(CODIGO_REGION_METROPOLITANA),
    },
    comuna: {
        codigo: '13101',
        nombre: 'Santiago',
    },
};

interface Props {
    regionComuna: Datos;
    requeridos?: boolean;
    onChange(regionComuna: Datos): void;
}

class RegionesComunas extends React.Component<Props> {
    private readonly regiones = json.regiones.map(region => region.option);

    public render() {
        const { regionComuna, requeridos = false, onChange, children } = this.props;

        return (
            <Form.Group>
                <Form.Select
                    label='Región'
                    placeholder='Seleccione'
                    required={requeridos}
                    options={this.regiones}
                    value={regionComuna.region.codigo}
                    onChange={(_e, { value }) => {
                        onChange({
                            ...regionComuna,
                            region: {
                                codigo: value as string,
                                nombre: nombreRegion(value as string),
                            },
                        });
                    }}
                    search
                    width='4'
                />

                <Form.Select
                    label='Comuna'
                    placeholder='Seleccione'
                    required={requeridos}
                    options={this.cambiarRegion()}
                    value={regionComuna.comuna.codigo}
                    onChange={(_e, { value }) => {
                        onChange({
                            ...regionComuna,
                            comuna: {
                                codigo: value as string,
                                nombre: nombreComuna(value as string),
                            },
                        });
                    }}
                    search
                    width='4'
                />

                {children}
            </Form.Group>
        );
    }

    private cambiarRegion() {
        const { region } = this.props.regionComuna;
        const regionSeleccionada = json.regiones.find(
            cadaRegion => cadaRegion.option.value === region.codigo,
        );
        return regionSeleccionada ? regionSeleccionada.comunas : arrayVacio;
    }
}

function nombreRegion(codigo: string) {
    const regionOption = json.regiones.find(region => region.option.value === codigo);
    return regionOption ? regionOption.option.text.replace(/^.+\ -\ /, '') : '';
}

function nombreComuna(codigo: string) {
    for (const region of json.regiones) {
        for (const comuna of region.comunas) {
            if (comuna.value === codigo) {
                return comuna.text;
            }
        }
    }
    return '';
}

export default RegionesComunas;



// WEBPACK FOOTER //
// ./src/modulos/Matriculas/IngresoNuevaMatricula/componentes/Direcciones/componentes/Direccion/componentes/RegionesComunas/index.tsx